import { AfterViewInit, Component, Inject, Injectable, InjectionToken, ModelFunction, Optional, Type, ViewChild, inject, model } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';
import { getBlob, getStorage, ref, uploadBytesResumable } from 'firebase/storage';

import moment from 'moment';

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { AlertService } from '../shared/alert/alert.service';

import { environment } from '../../../environments/environment';
import { currentUserUid } from '../../utils/firestore-ownership';

@Injectable({
  providedIn: 'root'
})
export class InvestimentsBase<C, M> {

  icons = environment.icons
  errorMessage: any

  protected service!:any
  // private createComponent:ComponentType<C>
  // private modifyComponent:ComponentType<M>

  private alert = inject(AlertService);

  private dialog = inject(MatDialog)

  public list: any = {
    columns: [],
    data: []  
  }
  
  constructor(
    private createComponent:Type<C>,
    private modifyComponent:Type<M>
  ) {
    // console.log('InvestimentsBase', 'constructor')
  }

  protected async ngOnInit(): Promise<void> {
    // console.error('InvestimentsBase -> ngOnInit')

    this.service.getAll().subscribe( (l:any) => {
      this.list.data = l
    })
  }

  protected ngOnDestroy(): void {
    // console.warn('InvestimentsBase -> ngOnDestroy')
  }

  create() {
    // console.error('InvestimentsBase -> create', this.createComponent.name)

    const dialogRef = this.dialog.open(this.createComponent, { disableClose: false })
    this.closedDialog(dialogRef)
  }

  modify(e: any) {
    // console.error('InvestimentsBase -> modify', this.modifyComponent.name)

    const dialogRef = this.dialog.open(this.modifyComponent, { disableClose: false, data: { ...e } })
    this.closedDialog(dialogRef)
  }

  async delete(e: any): Promise<void> {
    try {
      await this.service.delete(e);
      this.alert.show('Deleted!', 'delete_forever');
    } catch {
      this.alert.show('Delete failed!', 'error');
    }
  }

  async attach(e: any, event: Event) {
    const file = (event.target as HTMLInputElement).files?.item(0)
    if (!file) {
      this.alert.show('File not found!', 'fmd_bad')
      return;
    }

    if (file.type !== 'application/pdf' || file.size > 10 * 1024 * 1024) {
      this.alert.show('Select a PDF up to 10 MB.', 'error');
      return;
    }

    try {
      const ownerUid = currentUserUid();
      const itemName = String(e.share ?? e.id).replace(/[\\/]/g, '_');
      const fileName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
      const storageRef = ref(getStorage(), `TradeConfirmations/${ownerUid}/${itemName}/${crypto.randomUUID()}-${fileName}`);
      const uploadTask = uploadBytesResumable(storageRef, file, { contentType: 'application/pdf' });

      await new Promise<void>((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          snapshot => console.info('Upload progress', Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100)),
          reject,
          resolve
        );
      });

      await this.service.updateAttach(e, storageRef.fullPath, file.name);
      await this.service.selectAll();
      this.alert.show('File uploaded!', 'attach_file_add');
    } catch {
      this.alert.show('Upload failed!', 'fmd_bad');
    }
  }

  async downloadAttachment(attachment: { path: string; name: string }): Promise<void> {
    try {
      const blob = await getBlob(ref(getStorage(), attachment.path));
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = attachment.name;
      link.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch {
      this.alert.show('Download failed!', 'fmd_bad');
    }
  }

  closedDialog(dialogRef: MatDialogRef<C | M>) {
    // console.error('InvestimentsBase -> closedDialog', dialogRef.componentRef?.componentType.name)

    const type = dialogRef.componentRef?.componentType

    dialogRef.afterClosed().subscribe(async res => {
      // console.error('StocksComponent -> res.data.values', res)

      if(res?.data != undefined){

        if(type == this.createComponent){
          // console.error('StocksComponent -> closedDialog', type.name)

          try {
            if (await this.evaluate(res.data.values)) {
              await this.service.addItem(res.data.values);
              this.alert.show('Created!', 'save_as');
            }
          } catch {
            this.alert.show('Create failed!', 'error');
          }
        }

        if(type == this.modifyComponent){
          // console.error('StocksComponent -> closedDialog', type.name)

          try {
            if (await this.evaluate(res.data.values)) {
              await this.service.modify(res.data.values);
              this.alert.show('Modified!', 'save_as');
            } else {
              this.alert.show('Error!', 'error');
            }
          } catch {
            this.alert.show('Update failed!', 'error');
          }
        }

      } 
      else 
      {
        if(res != undefined && res?.data != undefined)
          this.alert.show('Data not found!', 'fmd_bad')
      }
    })
  }

  isNumber(o:any){
    // console.error('InvestimentsBase -> isNumber', o, (typeof o === 'number'))

    return typeof o === 'number'
  }

  isTimestamp(o:any){
    // console.error('InvestimentsBase -> isTimestamp', o, 'Type: ', o.seconds !== undefined)

    return o.seconds !== undefined
  }

  isText(o:any){
    // console.log('InvestimentsBase -> isText', o, (!this.isNumber(o)))

    return !this.isNumber(o) && !this.isTimestamp(o)
  }

  //To be overwritten
  protected async evaluate(e:any):Promise<boolean> { return await true }

}
